import { Controller } from '@hotwired/stimulus';
import { getComponent } from '@symfony/ux-live-component';

export default class extends Controller {
    async initialize () {
        this.component = await getComponent(this.element);

        const $profileForm = document.querySelector('[data-profile-form="root"]');

        const $countrySelect = $profileForm.querySelector('[data-country-code]');

        const $countrySelectBilling = $profileForm.querySelector('[data-country-billing-code]');

        const $billingAddressCheckbox = $profileForm.querySelector('[data-different-billing-address="checkbox"]');
        const $billingAddressLabel = $profileForm.querySelector('[data-different-billing-address="label"]');
        const $billingAddressContent = $profileForm.querySelector('[data-different-billing-address="content"]');

        let countryData;
        if ($countrySelect) {
            countryData = $countrySelect.getAttribute('data-country-code').toLowerCase();
        }

        let countryBillingData;
        if ($countrySelectBilling) {
            countryBillingData = $countrySelectBilling.getAttribute('data-country-billing-code').toLowerCase();
        }

        const handleAriaDifferentBillingAddress = () => {
            if ($billingAddressCheckbox.checked) {
                $billingAddressLabel.setAttribute('aria-pressed', 'true');
                $billingAddressContent.setAttribute('aria-hidden', 'false');
                $billingAddressContent.classList.add('is--visible');
            } else {
                $billingAddressLabel.setAttribute('aria-pressed', 'false');
                $billingAddressContent.setAttribute('aria-hidden', 'true');
                $billingAddressContent.classList.remove('is--visible');
            }
        };

        if ($billingAddressCheckbox != null) {
            handleAriaDifferentBillingAddress();
        }

        window.addEventListener('form:success', () => {
            $profileForm.querySelector('[data-modal-close-btn]').click();
        });

        this.component.on('render:finished', () => {
            if ($profileForm && countryData != null) {
                const currentSelectedCountry = $countrySelect.getAttribute('data-country-code').toLowerCase();
                if (currentSelectedCountry !== countryData) {
                    countryData = currentSelectedCountry;
                }

                if ($countrySelectBilling) {
                    const currentSelectedBillingCountry = $countrySelectBilling.getAttribute('data-country-billing-code').toLowerCase();
                    if (currentSelectedBillingCountry !== countryBillingData) {
                        countryBillingData = currentSelectedBillingCountry;
                    }
                }

                if ($billingAddressCheckbox != null) {
                    handleAriaDifferentBillingAddress();
                }
            }
        });
    }
}
